// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcw_a bic_wl","LoadingPlaceholder":"bcw_b bic_h","loading-placeholder":"bcw_c"};